module.exports = __webpack_public_path__ + "static/android-icon-192x192.bae5a350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/android-icon-192x192.png
// module id = 595
// module chunks = 114276838955818